import moment from 'moment-timezone';

import { EventData, EventDataSchema } from '@pwp-common';

import { DATETIME_LOCAL_CONTROL_STR_FORMAT } from '../../../../../../common/objects/form-helper';
import { EventCreateDialogEditorOutput } from '../event-create-dialog-editor-output';

export interface EventCreateDialogEditorOutputToDbInput {
  editorOutput: EventCreateDialogEditorOutput;
  type: string;
  timezone: string;
  id?: string;
  color?: string;
  eventConfigId?: string;
}

export const eventCreateDialogEditorOutputToDb = (params: EventCreateDialogEditorOutputToDbInput): EventData => {
  const { editorOutput, type, timezone, id = '', color, eventConfigId } = params;

  const start = moment.tz(editorOutput.startTime, DATETIME_LOCAL_CONTROL_STR_FORMAT, timezone);
  const end = moment.tz(editorOutput.endTime, DATETIME_LOCAL_CONTROL_STR_FORMAT, timezone);

  return new EventData({
    id,
    start,
    end,
    type,
    color: color ?? EventDataSchema.Defaults.color,
    assignedUserId: editorOutput.assignedUserId ?? EventDataSchema.Defaults.assignedUserId,
    assignedBackupUserId: editorOutput.assignedBackupUserId ?? EventDataSchema.Defaults.assignedBackupUserId,
    eventConfigId: eventConfigId ?? EventDataSchema.Defaults.eventConfigId,
  });
};
